/**
 * Bermudian dollar.
 */
export var BMD = {
  code: 'BMD',
  base: 10,
  exponent: 2
};